import React from "react";
import { Alert, Box, Button, Chip, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function FinanceSectionShell({ title, subtitle, countLabel, loading, error, onRetry, children, empty, emptyTitle, emptyBody, viewAllHref, viewAllLabel }) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
      <Box sx={{ px: { xs: 2, sm: 2.5 }, py: 2, backgroundColor: "#f4f6fa", display: "flex", justifyContent: "space-between", gap: 2, alignItems: "flex-start" }}>
        <Box>
          <Typography variant="h6" fontWeight={800}>{title}</Typography>
          <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
        </Box>
        {countLabel ? <Chip size="small" label={countLabel} color="primary" variant="outlined" /> : null}
      </Box>
      <Box sx={{ borderTop: 1, borderColor: "divider" }}>
        {loading ? (
          <Stack alignItems="center" sx={{ py: 5 }}><CircularProgress size={28} aria-label={`Loading ${title}`} /></Stack>
        ) : error ? (
          <Box sx={{ p: 2 }}>
            <Alert severity="error" action={<Button color="inherit" size="small" startIcon={<RefreshIcon />} onClick={onRetry}>Retry</Button>}>{error}</Alert>
          </Box>
        ) : empty ? (
          <Box sx={{ px: 2.5, py: 4, textAlign: "center" }}>
            <Typography fontWeight={800}>{emptyTitle}</Typography>
            <Typography variant="body2" color="text.secondary">{emptyBody}</Typography>
          </Box>
        ) : children}
      </Box>
      <Box sx={{ px: 2, py: 1.25, borderTop: 1, borderColor: "divider", textAlign: "right" }}>
        <Button component="a" href={viewAllHref} target="_blank" rel="noopener noreferrer" size="small" sx={{ textTransform: "none", fontWeight: 700 }}>{viewAllLabel} →</Button>
      </Box>
    </Paper>
  );
}
